var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from "react";
import tenantService from "../api-client/services/tenant";
import { defaultTenantSettings, } from "../submodules/Inventory-Module-Types/src/utils/tenant-config";
import { dropCookies, getSubdomain, messages, } from "../submodules/Inventory-Module-Types/src";
import { CookiesClear, SessionStorageExistence, } from "../submodules/Inventory-Module-Types/src/utils/storage";
export var ETheme;
(function (ETheme) {
    ETheme["LIGHT"] = "LIGHT";
    ETheme["DARK"] = "DARK";
})(ETheme || (ETheme = {}));
const initUser = {
    userExists: false,
    userLoading: true,
};
const defaultUserData = {
    id: undefined,
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    profileImage: "",
    role: undefined,
    referralLink: "",
    status: undefined,
    overallProgress: 0,
};
const applicationDefaultValue = {
    user: defaultUserData,
    auth: initUser,
    theme: ETheme.DARK,
    tenantSettings: defaultTenantSettings,
    setAuth: () => {
        // return void;
    },
    setUser: () => {
        // return void;
    },
    setTheme: () => {
        // return void;
    },
    setTenantSettings: (tenantSettings) => {
        //return void
    },
};
export const ApplicationContext = createContext(applicationDefaultValue);
export const ApplicationContextProvider = ({ children }) => {
    const [user, setUser] = useState(applicationDefaultValue.user);
    const [auth, setAuth] = useState(initUser);
    const [theme, setTheme] = useState(ETheme.DARK);
    const [tenantSettings, setTenantSettings] = useState(defaultTenantSettings);
    useEffect(() => {
        function initializeApp() {
            return __awaiter(this, void 0, void 0, function* () {
                yield fetchTenantSettings();
            });
        }
        initializeApp();
    }, []);
    const fetchTenantSettings = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        console.log("fetchTenantSettings");
        const existedTenant = SessionStorageExistence("tenant-config");
        const sessionData = SessionStorageExistence(messages.SESSION_INTERVIEW_META_DATA);
        const tenantName = ((_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.data) === null || _a === void 0 ? void 0 : _a.tenantSubdomain) ||
            getSubdomain((_b = sessionData === null || sessionData === void 0 ? void 0 : sessionData.data) === null || _b === void 0 ? void 0 : _b.app);
        console.log("tenantName in fetchTenantSettings:", tenantName);
        if (!existedTenant.isExist) {
            try {
                const response = yield tenantService.getTenantSettings(tenantName);
                // const response = await tenantService.getTenantSettings("nuvamawealth-staging");
                if (response.status === 200) {
                    const tenant = response.data;
                    onSuccessTenantSetup(tenant);
                }
            }
            catch (error) {
                onErrorTenantSetup();
            }
        }
        else {
            try {
                const tenant = existedTenant.data;
                onSuccessTenantSetup(tenant, false);
                const response = yield tenantService.getTenantSettings(tenantName);
                // const response = await tenantService.getTenantSettings("nuvamawealth-staging");
                if (response.status === 200) {
                    const updatedTenant = response.data;
                    const isMaintenance = ((_c = updatedTenant === null || updatedTenant === void 0 ? void 0 : updatedTenant.tenantConfig) === null || _c === void 0 ? void 0 : _c.isMaintenance) !==
                        tenant.tenantConfig.isMaintenance;
                    const isUpdated = (updatedTenant === null || updatedTenant === void 0 ? void 0 : updatedTenant.tenantConfig.updatedAt) !==
                        tenant.tenantConfig.updatedAt;
                    if (isMaintenance) {
                        onSuccessTenantSetup(updatedTenant);
                        CookiesClear("is_ad");
                        sessionStorage.clear();
                        window.location.href = `${(_d = sessionData === null || sessionData === void 0 ? void 0 : sessionData.data) === null || _d === void 0 ? void 0 : _d.app}/interview-profile`;
                        return;
                    }
                    if (isUpdated) {
                        onSuccessTenantSetup(updatedTenant);
                    }
                }
            }
            catch (error) {
                onErrorTenantSetup();
            }
        }
    });
    const onSuccessTenantSetup = (tenant, isUpdateStorage = true) => {
        dropCookies(tenant);
        setTenantSettings(tenant);
        if (isUpdateStorage)
            sessionStorage.setItem("tenant-config", JSON.stringify(tenant));
    };
    const onErrorTenantSetup = () => {
        dropCookies(defaultTenantSettings);
        setTenantSettings(defaultTenantSettings);
    };
    const value = {
        auth,
        user,
        theme,
        tenantSettings,
        setAuth,
        setUser,
        setTheme,
        setTenantSettings,
    };
    return (_jsx(ApplicationContext.Provider, Object.assign({ value: value }, { children: children })));
};
export const useApplicationContext = () => {
    return useContext(ApplicationContext);
};
